
import { WorldCountry } from '../types';
import { chinaSouthernCities } from './chinaSouthernCities';
import { chinaAdditionalCities2 } from './chinaExpansion2';

export const chinaData: WorldCountry = {
  name: 'China',
  slug: 'china',
  code: 'CN',
  population: 1439323776,
  topCities: [
    { name: 'Shanghai', slug: 'shanghai', population: 24281000 },
    { name: 'Beijing', slug: 'beijing', population: 21542000 },
    { name: 'Chongqing', slug: 'chongqing', population: 15872179 },
    { name: 'Tianjin', slug: 'tianjin', population: 13866009 },
    { name: 'Guangzhou', slug: 'guangzhou', population: 14043500 },
    { name: 'Shenzhen', slug: 'shenzhen', population: 12356820 },
    { name: 'Wuhan', slug: 'wuhan', population: 11081000 },
    { name: 'Chengdu', slug: 'chengdu', population: 10722000 },
    { name: 'Dongguan', slug: 'dongguan', population: 8220207 },
    { name: 'Xi\'an', slug: 'xian', population: 8000000 },
    { name: 'Foshan', slug: 'foshan', population: 7236512 },
    { name: 'Nanjing', slug: 'nanjing', population: 8505500 },
    { name: 'Shenyang', slug: 'shenyang', population: 8106171 },
    { name: 'Hangzhou', slug: 'hangzhou', population: 10360000 },
    { name: 'Qingdao', slug: 'qingdao', population: 9500000 },
    { name: 'Zhengzhou', slug: 'zhengzhou', population: 10350000 },
    { name: 'Jinan', slug: 'jinan', population: 8700000 },
    { name: 'Harbin', slug: 'harbin', population: 10635971 },
    { name: 'Kunming', slug: 'kunming', population: 8460088 },
    { name: 'Dalian', slug: 'dalian', population: 5950000 },
    { name: 'Changchun', slug: 'changchun', population: 7677089 },
    { name: 'Taiyuan', slug: 'taiyuan', population: 4201591 },
    { name: 'Shijiazhuang', slug: 'shijiazhuang', population: 10784600 },
    { name: 'Ürümqi', slug: 'urumqi', population: 3500000 },
    { name: 'Xiamen', slug: 'xiamen', population: 4044834 },
    { name: 'Changsha', slug: 'changsha', population: 8154700 },
    { name: 'Hefei', slug: 'hefei', population: 8186000 },
    { name: 'Nanchang', slug: 'nanchang', population: 5255000 },
    { name: 'Fuzhou', slug: 'fuzhou', population: 7740000 },
    { name: 'Wenzhou', slug: 'wenzhou', population: 9122100 },
    { name: 'Ningbo', slug: 'ningbo', population: 8200000 },
    { name: 'Tangshan', slug: 'tangshan', population: 7577284 },
    { name: 'Wuxi', slug: 'wuxi', population: 6372624 },
    { name: 'Xuzhou', slug: 'xuzhou', population: 8580500 },
    { name: 'Suzhou', slug: 'suzhou', population: 10721700 },
    { name: 'Yantai', slug: 'yantai', population: 7102116 },
    { name: 'Lanzhou', slug: 'lanzhou', population: 3616163 },
    { name: 'Guiyang', slug: 'guiyang', population: 4697339 },
    { name: 'Nanning', slug: 'nanning', population: 7254000 },
    { name: 'Haikou', slug: 'haikou', population: 2046189 },
    ...chinaSouthernCities,
    ...chinaAdditionalCities2
  ]
};
